import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import cx from 'classnames';
import Icon from '@components/@core/Icon';

class Input extends React.PureComponent {
    state = { focused: false, value: this.props.value || '' };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value !== prevState.value) {
            return { value: nextProps.value || '' };
        }
        return null;
    }

    handleBlur = (e) => {
        const value = e.target.value;
        this.props.onBlur(value);
        setTimeout(() => {
            this.setState({ focused: false });
        }, 100);
    };

    handleChange = (e) => {
        const { regx } = this.props;
        const value = regx ? e.target.value.replace(regx, '') : e.target.value;
        this.setState({ value });
        this.props.onChange(value);
    };

    handleClear = () => {
        this.props.onClear();
        this.setState({ value: '' });
        this.props.onChange('');
    };

    hanldeFocus = () => {
        this.setState({ focused: true });
        this.props.onFocus();
    };

    handleKeyPress = (e) => {
        if (e.charCode === 13) {
            this.props.onEnter();
        }
    };

    render() {
        const { className, direction, title, type, as, rows, disabled, remove, error, placeholder, required, inputRef, maxLength, tooltip, dataCy } = this.props;
        const { focused, value } = this.state;
        const classname = cx('core-input', className, direction, { focused }, { remove }, { error: !!error });
        const options = maxLength !== 0 ? { maxLength } : {};

        return (
            <div className={classname}>
                {title && (
                    <span className="core-input-label">
                        {title}
                        {required && <span className="ml-1">*</span>}
                    </span>
                )}
                <div className={`d-flex flex-column ${direction === 'horizontal' ? 'd-flex-1' : 'w-100'}`}>
                    <div className="core-input-content">
                        <Form.Control
                            {...options}
                            data-cy={dataCy}
                            disabled={disabled}
                            placeholder={placeholder}
                            ref={inputRef}
                            value={value}
                            type={type}
                            as={as}
                            rows={rows}
                            title={tooltip ? value : ''}
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            onFocus={this.hanldeFocus}
                            onKeyPress={this.handleKeyPress}
                        />
                        {!disabled && (
                            <>
                                <div className="clear" onClick={this.handleClear}>
                                    <Icon name="fas fa-xmark-circle cursor-pointer" color="#969faa" size={16} />
                                </div>
                                {maxLength !== 0 && (
                                    <p className="counter dsl-d11">
                                        {value.length}/{maxLength}
                                    </p>
                                )}
                                {remove && (
                                    <div className="delete">
                                        <Icon name="fas fa-trash-can-alt" color="#969faa" size={12} />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    {!disabled && error && <span className="error dsl-r12">{error}</span>}
                </div>
            </div>
        );
    }
}

Input.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    remove: PropTypes.bool,
    tooltip: PropTypes.bool,
    type: PropTypes.string,
    as: PropTypes.oneOf(['input', 'textarea']),
    rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    regx: PropTypes.instanceOf(RegExp),
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    inputRef: PropTypes.shape({ current: PropTypes.any }),
    direction: PropTypes.oneOf(['horizontal', 'vertical']),
    error: PropTypes.string,
    maxLength: PropTypes.number,
    onClear: PropTypes.func,
    onChange: PropTypes.func,
    onEnter: PropTypes.func,
    onFocus: PropTypes.func,
};

Input.defaultProps = {
    className: '',
    title: '',
    value: '',
    disabled: false,
    remove: false,
    tooltip: false,
    type: 'text',
    as: 'input',
    rows: '1',
    placeholder: '',
    required: false,
    regx: undefined,
    inputRef: { current: null },
    direction: 'horizontal',
    error: '',
    maxLength: 0,
    onClear: () => {},
    onBlur: () => {},
    onChange: () => {},
    onEnter: () => {},
    onFocus: () => {},
};

export default Input;
